import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ASSIGN_VENDOR_REMARKS_LIST, CANCELLATION_REMARKS_FOR_VENDOR, GET_CHAUFFEURS_LIST } from '../../../../../../../../store/actions';
import LoaderData from './LoaderData';
import ApprovalAction from './ApprovalAction';
import UpdateConfiguration from './UpdateConfig';
import PublishApproval from './PublishApproval';

export default function AirportTransferActionablesModals({
  currentSelectedBooking,
  currentActiveBookingAction,
  setCurrentActiveBookingAction,
  isMultiSelectable,
  bookingDetails,
  cardName,
}) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATE ---------------------------- */
  const [isShowApprovalActionForAirport, setIsShowApprovalActionForAirport] = useState(false);
  const [isShowRejectionActionForAirport, setIsShowRejectionActionForAirport] = useState(false);
  const [isShowApprovalActionForClient, setIsShowApprovalActionForClient] = useState(false);
  const [isShowRejectionActionForClient, setIsShowRejectionActionForClient] = useState(false);
  const [isShowApprovalActionForZone, setIsShowApprovalActionForZone] = useState(false);
  const [isShowRejectionActionForZone, setIsShowRejectionActionForZone] = useState(false);
  const [isShowApprovalActionForVendor, setIsShowApprovalActionForVendor] = useState(false);
  const [isShowRejectionActionForVendor, setIsShowRejectionActionForVendor] = useState(false);
  const [isShowApprovalActionForClientPricing, setIsShowApprovalActionForClientPricing] = useState(false);
  const [isShowRejectoionForClientPricing, setIsShowRejectoionForClientPricing] = useState(false);
  const [isShowApprovalActionForVendorPricing, setIsShowApprovalActionForVendorPricing] = useState(false);
  const [isShowRejectoionForVendorPricing, setIsShowRejectoionForVendorPricing] = useState(false);
  const [isShowApprovalActionForClientZones, setIsShowApprovalActionForClientZones] = useState(false);
  const [isShowRejectoionForClientZones, setIsShowRejectoionForClientZones] = useState(false);
  const [isShowPublishConfiguration, setIsShowPublishConfiguration] = useState(false);
  const [isShowPublishAirport, setIsShowPublishAirport] = useState(false);
  const [isShowPublishVendor, setIsShowPublishVendor] = useState(false);
  const [isShowPublishClient, setIsShowPublishClient] = useState(false);
  const [isShowPublishZone, setIsShowPublishZone] = useState(false);
  const [isShowRevoke, setIsShowRevoke] = useState(false);

  useEffect(() => {
    if (currentActiveBookingAction !== null) {
      switch (currentActiveBookingAction) {
        case `approve_airport`:
          setIsShowApprovalActionForAirport(true);
          break;

        case `reject_airport`:
          setIsShowRejectionActionForAirport(true);
          break;

        case `approve_zone`:
          setIsShowApprovalActionForZone(true);
          break;

        case `reject_zone`:
          setIsShowRejectionActionForZone(true);
          break;

        case `approve_vendor`:
          setIsShowApprovalActionForVendor(true);
          break;

        case `reject_vendor`:
          setIsShowRejectionActionForVendor(true);
          break;

        case `approve_client`:
          setIsShowApprovalActionForClient(true);
          break;

        case `reject_client`:
          setIsShowRejectionActionForClient(true);
          break;

        case `approve_client_pricing`:
          setIsShowApprovalActionForClientPricing(true);
          break;

        case `reject_client_pricing`:
          setIsShowRejectoionForClientPricing(true);
          break;

        case `approve_vendor_pricing`:
          setIsShowApprovalActionForVendorPricing(true);
          break;

        case `reject_vendor_pricing`:
          setIsShowRejectoionForVendorPricing(true);
          break;

        case `approve_client_zone`:
          setIsShowApprovalActionForClientZones(true);
          break;

        case `reject_client_zone`:
          setIsShowRejectoionForClientZones(true);
          break;

        case `publish_config`:
          setIsShowPublishConfiguration(true);
          break;

        case `publish_airport`:
          setIsShowPublishAirport(true);
          break;

        case `publish_zone`:
          setIsShowPublishZone(true);
          break;

        case `publish_client`:
          setIsShowPublishClient(true);
          break;

        case `publish_vendor`:
          setIsShowPublishVendor(true);
          break;

        case `revoke_configuration`:
          setIsShowRevoke(true);
          break;

        default:
      }
    }
  }, [currentActiveBookingAction]);

  return (
    <>
      <LoaderData setCurrentActiveBookingAction={setCurrentActiveBookingAction} />

      {isShowApprovalActionForAirport && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForAirport(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'airport'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectionActionForAirport && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectionActionForAirport(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'airport'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForZone && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForZone(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'zone'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectionActionForZone && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectionActionForZone(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'zone'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForClient && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForClient(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'client'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectionActionForClient && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectionActionForClient(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'client'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForVendor && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForVendor(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'vendor'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectionActionForVendor && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectionActionForVendor(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'vendor'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForClientPricing && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForClientPricing(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'client'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectoionForClientPricing && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectoionForClientPricing(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'client'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForVendorPricing && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForVendorPricing(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'vendor'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectoionForVendorPricing && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectoionForVendorPricing(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'vendor'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowApprovalActionForClientZones && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowApprovalActionForClientZones(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="approve"
          approvalType={'client zone'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowRejectoionForClientZones && (
        <ApprovalAction
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRejectoionForClientZones(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="reject"
          approvalType={'client zone'}
          cardName={cardName}
          currentActiveBookingAction={currentActiveBookingAction}
        />
      )}

      {isShowPublishConfiguration && (
        <UpdateConfiguration
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowPublishConfiguration(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="publish"
        />
      )}

      {isShowRevoke && (
        <UpdateConfiguration
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowRevoke(false);
            setCurrentActiveBookingAction(null);
          }}
          actionType="revoke"
        />
      )}

      {isShowPublishAirport && (
        <PublishApproval
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowPublishAirport(false);
            setCurrentActiveBookingAction(null);
          }}
          approvalType={'airport'}
          cardName={cardName}
        />
      )}

      {isShowPublishVendor && (
        <PublishApproval
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowPublishVendor(false);
            setCurrentActiveBookingAction(null);
          }}
          approvalType={'vendor'}
          cardName={cardName}
        />
      )}

      {isShowPublishClient && (
        <PublishApproval
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowPublishClient(false);
            setCurrentActiveBookingAction(null);
          }}
          approvalType={'client'}
          cardName={cardName}
        />
      )}

      {isShowPublishZone && (
        <PublishApproval
          currentSelectedBooking={currentSelectedBooking?.[0]}
          onClose={() => {
            setIsShowPublishZone(false);
            setCurrentActiveBookingAction(null);
          }}
          approvalType={'zone'}
          cardName={cardName}
        />
      )}
    </>
  );
}
